import React from "react";
import { observer } from "mobx-react";
import { Grid } from "@mui/material";

const Literal = ({ title, text }) => (
  <Grid container direction="column" spacing={0}>
    <Grid item>
      <label>{title}</label>
    </Grid>
    <Grid item xs>
      <p>{text}</p>
    </Grid>
  </Grid>
);

export default observer(Literal);
